/**
 * Все расчётные зависимости, относящиеся к дисциплине Отопление и Вентиляция находятся в этом модуле
 */

import { Graf } from "../models/nets/GraphExtension";
import { ObjectTypes } from "../shared/enums";
import { findElementByNodeId, updateGraphNodesCoordinatesZoom, createNodeGraph } from "./graph&network";
import { getDisplayedShapes } from "../shared/state";
import { ElbowBlock } from "../models/resistances/ElbowBlock";
import { Block } from "../models/shapes/Block";
import { Line } from "../models/shapes/Line";
import { Tee } from "../models/resistances/Tee";


const t = 20;
const roughness = 0.1;

function getLenSum(route: any) {
    return route.reduce((sum: number, x: any) => sum + x.getLen(), 0);
}
function getAirDens(t: number) {
    return 353 / (273 + t);
}

/**
 * Функция возвращает плотность воды по формуле Чепмена (??? источник - gigaChat)
 */

function getWaterDens(temperature: number) {

    // TODO: найти зависимость и скорректировать функцию

    return 1000;
}
function getAirDinViscosity(t: number) {
    // mu
    return 9.80665 * (1.745 * 10 ** (-6) + 5.03 * 10 ** (-9) * t);
}
function getWaterDinViscosity(t: number) {
    // mu
    return 2.414 * 10 ** (-5) * 10 ** (247.8 / (t + 133.15));
}
function getAirKinViscosity(t: number) {
    // nu
    var dens = getAirDens(t);
    return getAirDinViscosity(t) / dens;
}
function getWaterKinViscosity(t: number) {
    // nu
    var dens = 1000;
    return getWaterDinViscosity(t) / dens;
}
function getRe(v: number, d: number, nu: number) {
    return (v * d) / nu;
}

function getHydraulicDiameter(widthMeter: number, heightMeter: number) {
    return (2 * widthMeter * heightMeter) / (widthMeter + heightMeter);
}
function getDpRoundAir(diameterMIL: number, flowRateCMH: number, lenMET: number) {
    var diameterMET = diameterMIL / 1000;
    var area = Math.PI * ((diameterMET / 2) ** 2);
    var v = getVelocityRound(diameterMIL, flowRateCMH);
    var nu = getAirKinViscosity(t);
    var re = getRe(v, diameterMET, nu);
    var lambda = getLambda(re, diameterMIL);
    var dens = getAirDens(t);
    var dp = lenMET * lambda * ((dens * v ** 2) / (2 * diameterMET));

    return dp;
}
function getDpRectAir(widthMillimeter: number, heightMillimeter: number, flowCubicMeterPerHour: number, lenMeter: number) {
    var widthMeter = widthMillimeter / 1000;
    var heightMeter = heightMillimeter / 1000;
    var area = widthMeter * heightMeter;
    var v = getVelocityRect(widthMillimeter, heightMillimeter, flowCubicMeterPerHour);
    var dMeter = getHydraulicDiameter(widthMeter, heightMeter);
    var nu = getAirKinViscosity(t);
    var re = getRe(v, dMeter, nu);
    var lambda = getLambda(re, dMeter * 1000);
    var dens = getAirDens(t);


    if (lenMeter) {
        var dp = lenMeter * lambda * ((dens * v ** 2) / (2 * dMeter));
    }
    else {
        var dp = 0;
    }


    return dp;
}
function getLambda(re: number, dMillimeter: number) {
    return 0.11 * ((roughness / dMillimeter) + (0.68 / re)) ** 0.25;
}
function getVelocityRound(diameterMillimeter: number, flowCubicMeterPerHour: number) {

    var diameterMeter = diameterMillimeter / 1000;
    var area = Math.PI * ((diameterMeter / 2) ** 2);
    var velocity = (flowCubicMeterPerHour / 3600) / area;
    return velocity;
}
function getVelocityRect(widthMillimeter: number, heightMillimeter: number, flowCubicMeterPerHour: number) {
    var widthMeter = widthMillimeter / 1000;
    var heightMeter = heightMillimeter / 1000;
    var area = widthMeter * heightMeter;
    var velocity = (flowCubicMeterPerHour / 3600) / area;
    return velocity;
}

/**
 * Функция возвращает потери давления в местном сопротивлении
 * @param {ObjectTypes} env - среда (вода или воздух)
 * @param {Number} kms - коэффициент местного сопротивления
 * @param {Number} velocity - скорость потока
 */
export function getDpByKms(env: any, kms: number, velocity: number) {
    var dp = 0;


    if (env === ObjectTypes.water) {
        dp = kms * (getWaterDens(t) * velocity ** 2) / 2;
        return dp;
    }
    if (env === ObjectTypes.air) {
        dp = kms * (getAirDens(t) * velocity ** 2) / 2;
        return dp;
    }

    return null;

}

/**
 * Функция принимает строку с размером воздуховода, прямоугольного или круглого,
 * и возвращает в случае с прямоугольным воздуховодом - массив, а в случае с круглым - число
 */
export function parseAirDuctSize(inputString: string): number | [number, number] | undefined {
    // Регулярное выражение для поиска чисел, разделенных различными символами-разделителями
    const rectangularRegex = /(\d+)\s*[,\.\s;\/xXхХ]\s*(\d+)/;

    // Регулярное выражение для поиска одного числа (диаметр)
    const circularRegex = /^\s*(\d+)\s*$/;

    let result: number | [number, number] | undefined;

    // Сначала пытаемся обработать прямоугольный воздуховод
    const rectangularMatch = inputString.match(rectangularRegex);
    if (rectangularMatch && rectangularMatch.length === 3) {
        result = [parseInt(rectangularMatch[1]), parseInt(rectangularMatch[2])] as [number, number];
    } else {
        // Затем проверяем на круглый воздуховод
        const circularMatch = inputString.match(circularRegex);
        if (circularMatch && circularMatch.length === 2) {
            result = parseInt(circularMatch[1]);
        } else {
            console.warn('!! Неверный формат размера воздуховода');
        }
    }

    return result;
}


export { getDpRectAir, getDpRoundAir, getVelocityRect, getVelocityRound }